<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dokumenty elektroniczne</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja dokumentu elektronicznego</template>
          <template v-else>Dodawanie dokumentu elektronicznego</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/dokumenty-elektroniczne')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer ref="services-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa dokumentu:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'category_id'"
                  v-slot="{ errors }">
                  <div class="form-group" style="margin-bottom: 1.8rem;">
                    <label class="title-box" :for="data.category_id">
                      Kategoria dokumentu:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      :options="documentCategory"
                      :reduce="type => type.id"
                      v-model="data.category_id"
                      placeholder="Wybierz kategorie dokumentu"
                      label="name">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.category_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -1.4rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="description">
                  Krótki opis:
                </label>
                <validation-provider
                  name="description"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    ::autocomplete="data"
                    v-model="data.description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="uploaded_file">
                  Dodaj dokument:
                </label>
                <validation-provider
                  :rules="'required'"
                  :name="'file_type'"
                  v-slot="{ errors }">
                  <file-input
                    :class="['form-group', 'mr-2', (importantFile === true && !data.uploaded_file && !data.filename) ? 'invalid-file' : '']"
                    :onChange="setImage"
                    :id="'file_type'"/>
                </validation-provider>
                <div v-if="isEdit && data.filename && !data.uploaded_file" class="mt-1">
                  Aktualny dokument: {{ data.filename }}
                </div>
                <div class="invalid-feedback-file" style="display: block;" v-if="importantFile === true && !data.uploaded_file && !data.filename">
                  To pole jest wymagane
                </div>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'edocuments-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.edocuments;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        name: '',
        category_id: '',
        description: '',
        filename: '',
        id: '',
        uploaded_file: ''
      },
      edocuments: [],
      documentCategory: [],
      loaded: false,
      loadError: false,
      importantFile: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
    this.getDocumentCategory();
  },
  methods: {
    setImage(event) {
      this.data.uploaded_file = event.target.files[0];
    },
    getDocumentCategory () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/edocuments/category/items',
        outputKey: 'documentCategory',
        params: {
          pagination: false
        },
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/edocuments/item/',
        instanceFields: ['name', 'category_id', 'description', 'filename', 'id', 'uploaded_file'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/edocuments/items',
        params: {
          pagination: false
        },
        outputKey: 'edocuments',
        loadedKey: 'loadedCategories',
        errorKey: 'loadError',
      });
    },
    validateForm () {
      this.importantFile = true
      const fileOk = this.data.uploaded_file || (this.isEdit && this.data.filename);
      if (fileOk) {
        FormUtils.validate(this.$refs['services-form'], this.submitForm);
      } else {
        FormUtils.validate(this.$refs['services-form']);
      }
    },
    submitForm () {
      let imageFields = false;
      let formDataToSend = {
        name: this.data.name,
        category_id: this.data.category_id,
        description: this.data.description,
        filename: this.data.filename,
        id: this.data.id,
        uploaded_file: this.data.uploaded_file,
      };

      if (this.data.uploaded_file) {
        formDataToSend.image = this.data.uploaded_file;
        imageFields = ['image'];
      }
      let endpointUrl = this.isEdit ? '/edocuments/update/' + this.id : '/edocuments/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano dokument',
        successText: 'Wybrany dokument elektroniczny został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje dokumentu elektronicznego nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/dokumenty-elektroniczne')
        }
      }, imageFields);
    }
  }
};
</script>
